
import makerjs from "makerjs";

/**
 * 计算一元二次方程
 * 两个不同实数根的示例（x² - 5x + 6 = 0）：
 * const result1 = solveQuadraticEquation(1, -5, 6);
  console.log(result1);
// 输出: { roots: [3, 2], type: "两个不同的实数根" }
 * 
 */
 function solveQuadraticEquation(a, b, c) {
  // 计算判别式
  const delta = b * b - 4 * a * c;
  
  if (delta > 0) {
      // 两个不同的实数根
      const x1 = (-b + Math.sqrt(delta)) / (2 * a);
      const x2 = (-b - Math.sqrt(delta)) / (2 * a);
      return { roots: [x1, x2], type: "两个不同的实数根" };
  } else if (delta === 0) {
      // 两个相等的实数根
      const x = -b / (2 * a);
      return { roots: [x], type: "两个相等的实数根" };
  } else {
      // 无实数根(复数根)
      const realPart = -b / (2 * a);
      const imagPart = Math.sqrt(-delta) / (2 * a);
      return {
          roots: [
              { real: realPart, imag: imagPart },
              { real: realPart, imag: -imagPart }
          ],
          type: "两个复数根"
      };
  }
}

/**
        * 已知两个拱高，根据拱高和半径的关系，建立方程组：R=(L*L+4*h*h)/8*h
        * a+b=w  L1=2a  L2=2b
        * (L1*L1+4*h1*h1)/8*h1=(L2*L2+4*h2*h2)/8*h2
        * 求 a,b
        * hd1=h2-h1,hd2=h2-h1,
        * (hd2-hd1)x*x+2hd1*w*x+(hd1*hd1*hd2)-(hd2*hd2*hd1+w*w*hd1)=0
        */

function A43(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, H1 = Param[2].param,H2 = Param[3].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       h1 = H1 * 1 * myZoom,
       h2 = H2 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       hd1=h2-h1,hd2=h2-h;
       /**
        * hd1=h2-h1,hd2=h2-h1,
        * (hd2-hd1)x*x+2*hd1*w*x+(hd1*hd1*hd2)-(hd2*hd2*hd1+w*w*hd1)=0
        */
        const a=hd2-hd1;
        const b=2*hd1*w;
        const c=(hd1*hd1*hd2)-(hd2*hd2*hd1+w*w*hd1);
 console.log("a=,b=,c=",a,b,c);
     const result = solveQuadraticEquation(a, b, c);
     console.log("根的类型:", result.type);
     console.log("根的值:", result.roots[0]);
    // alert(`方程根的类型: ${result.type}\n根的值: ${JSON.stringify(result.roots)}`);
 var  x0 = 0, x1 = 0, x2 = w, x3 = w, y0 = 0, y1 = h1, y2 = h, y3 = 0,xp=result.roots[0],yp=h2,glassH = h, glassW = w;
 


   if (h !== 0) {
       var TxtH = H;
   } if (h2 !== 0) {
    var TxtH2 = H2;
} if (h1 !== 0) {
  var TxtH1 = H1;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA43 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "ArcLine": new makerjs.paths.Arc([x1,y1], [xp,yp],[x2, y2]),
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeA43MarkH1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0 - markShift, y0], [x0 - markShift, y1]),
        "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
        "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeA43MarkH2 = {
       paths: {
        "UpLine": new makerjs.paths.Line([xp, y0], [xp, yp]),
        // "UpShortLfline": new makerjs.paths.Line([x1, y2], [x1, y2 + 2 * markShift]),
        // "UpShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
   };
   var drawAbnormalShapeA43MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x3+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x3, y2], [x3+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeA43MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA43MarkW, TxtW, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA43MarkH2, TxtH2, [xp+markShift, y0], [xp+markShift, yp]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeA43MarkH, TxtH, [x3 + 2 * markShift, y3], [x3 + 2 * markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA43MarkH1, TxtH1, [x0 - 2 * markShift, y0], [x0 - 2 * markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA43: drawAbnormalShapeA43,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA43: drawAbnormalShapeA43,
        drawAbnormalShapeA43MarkH2: drawAbnormalShapeA43MarkH2,
        drawAbnormalShapeA43MarkH1: drawAbnormalShapeA43MarkH1,
        drawAbnormalShapeA43MarkH:drawAbnormalShapeA43MarkH,
        drawAbnormalShapeA43MarkW:drawAbnormalShapeA43MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A43;